import React from 'react';

const EULAFunoAI = () => {
    return (
        <div className="min-h-screen bg-dark pt-24 pb-16">
            <div className="max-w-screen-md mx-auto px-6">
                <h1 className="text-3xl font-custom1 text-white mb-6">End-User License Agreement (EULA)</h1>

                <p className="text-lg font-custom2 text-gray-300 mb-4">
                    This End-User License Agreement ("Agreement") is a legal agreement between you ("User") and Funo AI ("We" or "Our") that governs your use of the Funo AI Voice Changer mobile application and services. By installing or using Funo AI, you agree to be bound by this Agreement. If you do not agree to the terms of this Agreement, you must not install or use Funo AI.
                </p>

                <h2 className="text-2xl font-custom1 text-white mb-4">1. License Grant</h2>
                <p className="text-lg font-custom2 text-gray-300 mb-4">
                    We grant you a limited, non-transferable, revocable license to use Funo AI Voice Changer on any compatible device that you own or control. This license is for personal, non-commercial use only.
                </p>

                <h2 className="text-2xl font-custom1 text-white mb-4">2. License Restrictions</h2>
                <p className="text-lg font-custom2 text-gray-300 mb-4">
                    You agree not to:
                </p>
                <ul className="list-disc ml-6 mb-4 text-gray-300 font-custom2">
                    <li>Modify, reverse engineer, or create derivative works of Funo AI.</li>
                    <li>Use Funo AI to infringe on the rights of any third party.</li>
                    <li>Interfere with or disrupt the operation or security of the app.</li>
                </ul>

                <h2 className="text-2xl font-custom1 text-white mb-4">3. Updates and Changes</h2>
                <p className="text-lg font-custom2 text-gray-300 mb-4">
                    We may update Funo AI periodically with new features, content, or improvements. You agree to install any available updates for continued optimal use.
                </p>

                <h2 className="text-2xl font-custom1 text-white mb-4">4. Data Collection</h2>
                <p className="text-lg font-custom2 text-gray-300 mb-4">
                    Funo AI Voice Changer collects limited personal data to enhance your experience and ensure app functionality. This includes:
                </p>
                <ul className="list-disc ml-6 mb-4 text-gray-300 font-custom2">
                    <li>Email address (if provided for account or support)</li>
                    <li>Password (if account-based features are used; encrypted and stored securely)</li>
                    <li>Device identifier (used for analytics, security, and account management)</li>
                    <li>Voice recordings and audio data (only for processing within the app, not stored unless explicitly saved by the user)</li>
                </ul>
                <p className="text-lg font-custom2 text-gray-300 mb-4">
                    For more information on how we use and protect this data, please see our <a href="/privacy-policy" className="text-accent-orange hover:underline">Privacy Policy</a>.
                </p>

                <h2 className="text-2xl font-custom1 text-white mb-4">5. Termination</h2>
                <p className="text-lg font-custom2 text-gray-300 mb-4">
                    This Agreement remains effective until terminated by either party. We reserve the right to terminate access to Funo AI at any time if you violate this Agreement. Upon termination, you must uninstall the app.
                </p>

                <h2 className="text-2xl font-custom1 text-white mb-4">6. Limitation of Liability</h2>
                <p className="text-lg font-custom2 text-gray-300 mb-4">
                    To the maximum extent permitted by law, Funo AI shall not be liable for any indirect, incidental, or consequential damages resulting from your use of the app.
                </p>

                <h2 className="text-2xl font-custom1 text-white mb-4">7. Governing Law</h2>
                <p className="text-lg font-custom2 text-gray-300 mb-4">
                    This Agreement shall be governed by and construed under the laws applicable in your country or region, unless otherwise required by local law.
                </p>

                <h2 className="text-2xl font-custom1 text-white mb-4">Contact Us</h2>
                <p className="text-lg font-custom2 text-gray-300 mb-4">
                    For any questions regarding this Agreement, please contact us at: <a href="mailto:samedakgul99@gmail.com" className="text-accent-orange hover:underline">samedakgul99@gmail.com</a>.
                </p>
            </div>
        </div>
    );
};

export default EULAFunoAI;
